/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/bank-accounts';

export const BankAccountApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findBankAccountByOwner: async (option: FindBankAccountQuery) => {
    let url = `${pathname}/find-by-owner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterBankAccountOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  bankID?: string;
  entityID?: string;
  status?: number;
}

export interface FindBankAccountQuery {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  bankID?: string;
  ownerIDs?: string;
  status?: number;
  ownerID?: string;
}
